import React, { useState } from "react";
import { Button } from "@blueprintjs/core";

export default function AsyncButton(properties) {
  const { onClick, children, ...other } = properties;
  const [busy, setBusy] = useState(false);

  function invoke(e) {
    setBusy(true);
    setTimeout(async () => {
      try {
        await onClick(e);
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
      setBusy(false);
    }, 10);
  }

  if (busy) {
    return <Button loading />;
  }

  return (
    <Button {...other} onClick={invoke}>
      {children}
    </Button>
  );
}